import React, { useEffect, useState } from "react";
import {
  Grid,
  Paper,
  Box,
  Typography,
  CircularProgress,
  Button,
} from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import HeaderIcons from "../../Images/headericon.png";
import Strategies from "./Strategies";
import { useSelector, useDispatch } from "react-redux";
import {
  getCustodians,
} from "../../Redux/Actions/strategyService";
import { useNavigate } from "react-router-dom";

function Index() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { Custodians } = useSelector((state) => state.strategy);
  const [value, setValue] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(getCustodians());
  }, [dispatch]);

  useEffect(() => {
    if (Custodians && Custodians.length > 0) {
      setLoading(false);
    } else if (Custodians && Custodians.length === 0) {
      setLoading(false);
    }
  }, [Custodians]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleAddStrategyClick = () => {
    navigate("/addstrategy");
  };

  return (
    <>
      <Grid item xs={12}>
        <Paper
          sx={{ p: 2, display: "flex", flexDirection: "column" }}
          elevation={0}
        >
          <div className="row rows" style={{ marginLeft: "2px" }}>
            <div className="col-1">
              <img src={HeaderIcons} alt="Header Icon" width="45" height="45" />
            </div>
            <div
              className="col-9"
              style={{ marginTop: "10px", marginLeft: "-3%" }}
            >
              <p style={{ fontSize: "20px", color: "#18275A" }}>
                All Strategies
              </p>
            </div>
            <div
              className="col-2"
              style={{
                marginTop: "20px",
                marginBottom: "-50px",
                marginLeft: "19px",
              }}
            >
              <Button
                id="demo-customized-button"
                variant="contained"
                disableElevation
                onClick={handleAddStrategyClick}
                style={{
                  marginLeft: "8%",
                  textTransform: "none",
                  width: "150px",
                  transition: "background-color 0.3s, color 0.3s",
                  backgroundColor: "#1976D2",
                  color: "#FFFFFF",
                  "&:hover": {
                    backgroundColor: "#1565C0",
                  },
                }}
              >
                Add Strategy
              </Button>
            </div>
          </div>
          <Box
            sx={{
              width: "100%",
              typography: "body1",
              height: "50px",
              overflow: "hidden",
            }}
          >
            {loading ? (
              <CircularProgress style={{ alignSelf: "center" }} />
            ) : Custodians && Custodians.length > 0 ? (
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="lab API tabs example"
                sx={{
                  minHeight: "50px",
                  height: "50px",
                }}
              >
                <Tab
                  value="All"
                  label="All"
                  sx={{
                    borderRadius: "10px",
                    maxWidth: "100px",
                    margin: "0 5px",
                    fontSize: "14px",
                    fontWeight: "300",
                    color: "#000 !important",
                    height: "30px",
                  }}
                />
                {Custodians?.map((val) => (
                  <Tab
                    key={val?.name}
                    value={val?.name}
                    label={val?.name}
                    sx={{
                      borderRadius: "10px",
                      maxWidth: "200px",
                      margin: "0 5px",
                      fontSize: "14px",
                      fontWeight: "300",
                      color: "#000 !important",
                      height: "30px",
                    }}
                  />
                ))}
              </Tabs>
            ) : (
              <Typography
                variant="h6"
                style={{ textAlign: "center", marginTop: "20px" }}
              >
                Sorry, no Custodian data exists.
              </Typography>
            )}
          </Box>
        </Paper>
      </Grid>

      <Strategies custodian={value} />
    </>
  );
}

export default Index;
